import { getRegisteredGlobal, registerGlobal } from "@trumpf/ux.utils";
import { TrumpfUxConfig, UxSetupConfig } from "./globals";
import { version } from "../../package.json";

export const CONFIG_DEFAULT: TrumpfUxConfig = {
    version: version,
    theme: "web",
    assetPath: "./themes/",
    logLevel: "warn",
    setup: (config: UxSetupConfig) => {
        const previousConfig: TrumpfUxConfig = getRegisteredGlobal<TrumpfUxConfig>("trumpf.ux") || {};
        registerGlobal({ ...previousConfig, ...config }, "trumpf.ux");
    },
    /**
     * @deprecated Use `trumpf.ux.setup` instead.
     */
    setLogLevel: (level: "debug" | "info" | "warn" | "error") => {
        registerGlobal(level, "trumpf.ux.logLevel");
    }
};
